import React, { useState,useEffect } from 'react';
import { useNavigate,useLocation } from "react-router-dom";
import '../header/header.css';
import '../../App.css';
import logoImg from '../../images/carter-logo.svg';
import axios from 'axios';
import Modal from '../login/loginPopup';
import {END_URL} from '../../config';
import { NavLink } from 'react-router-dom';

function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
   

    const user = JSON.parse(sessionStorage.getItem('user')) || { name: 'User' };


    const handleLogout = () => {
        sessionStorage.clear();
        setIsLogin(false);  // Update state immediately
        navigate('/');
      };
      


    const [registerData, setRegisterData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        dob: '',
        occupation: ''
    });

  
    const [registerError, setRegisterError] = useState({});
    const [registerMessage, setRegisterMessage] = useState('');

    const [loginData, setLoginData] = useState({
        email: '',
        password: ''
    });

    const [loginError, setLoginError] = useState('');
    const [loginMessage, setLoginMessage] = useState('');

    // New state variables for forgot password
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [forgotPasswordMessage, setForgotPasswordMessage] = useState('');
    const [forgotPasswordError, setForgotPasswordError] = useState('');

    const [IsLogin, setIsLogin] = useState(false);

    const token_user = sessionStorage.getItem('authToken');

    useEffect(() => {

        if(token_user)
        {
            setIsLogin(true);
        }
       
      }, [token_user]);

    const handleRegisterChange = (e) => {
        const { name, value } = e.target;
        setRegisterData({ ...registerData, [name]: value });
    };

    const validateRegisterForm = () => {
        let errors = {};
        const { name, email, phone, address, dob, occupation } = registerData;

        if (!name) errors.name = 'Name is required';

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!email || !emailRegex.test(email)) errors.email = 'Invalid email address';

        if (!phone) errors.phone = 'Phone is required';

        if (!address) errors.address = 'Address is required';

        if (!dob) errors.dob = 'Date of Birth is required';

        if (!occupation) errors.occupation = 'Occupation is required';

        return errors;
    };

    const handleRegisterSubmit = async () => {
        setRegisterError({});

        const errors = validateRegisterForm();

        if (Object.keys(errors).length > 0) {
            setRegisterError(errors);
            return;
        }

        try {
            const response = await axios.post(
                `${END_URL}signup`,  registerData, {
                headers: { "Content-Type": "application/json" },
            });

            setRegisterMessage('Registration successful! Check your email to set your password');
            setRegisterData({ name: '', email: '', phone: '', address: '', dob: '', occupation: '' });
        } catch (error) {
            console.error("Error:", error.response?.data);
            if (error.response?.data?.message === "The email has already been taken.") {
                setRegisterError({ email: "Email id already exist" });
            } else {
                setRegisterMessage("Signup failed! Please try again.");
            }
        }
    };

    const handleLoginChange = (e) => {
        const { name, value } = e.target;
        setLoginData({ ...loginData, [name]: value });
    };

    const handleLoginSubmit = async () => {
        setLoginError('');
        setLoginMessage('');

        try {
            const response = await axios.post(
                `${END_URL}login`,  loginData, {
                headers: { "Content-Type": "application/json" },
            });

            // Extract token and store it in session storage
            const token = response.data.token;
            if (token) {
                sessionStorage.setItem('authToken', token);

                console.log(sessionStorage.getItem('authToken'));

                setModalType('');
            }


            const userStatus = response.data.user?.status;

            if (userStatus !== 'active') {
                setLoginError('Your account is inactive. Please contact the administrator.');
                sessionStorage.removeItem('authToken');
                return;
            }



            setLoginMessage('Login successful!');

            navigate('/dashboard');

        } catch (error) {
            console.error("Error:", error.response?.data);
            setLoginError('Invalid credentials. Please try again.');
        }
    };

    const handleForgotPasswordChange = (e) => {
        setForgotPasswordEmail(e.target.value);
    };

    const handleForgotPasswordSubmit = async () => {
        setForgotPasswordError('');
        setForgotPasswordMessage('');

        if (!forgotPasswordEmail) {
            setForgotPasswordError('Email is required');
            return;
        }

        try {
            const response = await axios.post(
                `${END_URL}forgot-password`, { email: forgotPasswordEmail }, {
                headers: { "Content-Type": "application/json" },
            });

            setForgotPasswordMessage('A password reset link has been sent to your email.');
        } catch (error) {
            console.error("Error:", error.response?.data);
            setForgotPasswordError('Failed to send reset link. Please try again.');
        }
    };


    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];


    return (
        <section className="head-main">
            <div className="container">
                <nav className="navbar navbar-expand-lg bg-body-tertiary">
                    <div className="container-fluid">
                        <a className="navbar-brand" href="/">
                            <img src={logoImg} alt="Header" />
                        </a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
  <li className="nav-item">
    <NavLink to="/" end className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>
      Home
    </NavLink>
  </li>
  <li className="nav-item">
    <NavLink to="/aboutPage" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>
      About
    </NavLink>
  </li>
  <li className="nav-item">
    <NavLink to="/contact" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>
      Contact
    </NavLink>
  </li>

  <li className="nav-item">
      <a className="nav-link"
        
            style={{ cursor: "pointer" }}
            onClick={() => {

                if (location.pathname === "/") {
                const el = document.getElementById("eligibility");
                if (el) {
                    const yOffset = -150;
                    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({ top: y, behavior: "smooth" });
                }
                } else {
                navigate("/#eligibility");
                }

            }}
        > 
         Eligibility
    </a>

    

  </li>
  <li className="nav-item">
    <a className="nav-link"

        style={{ cursor: "pointer" }}
        onClick={() => {

            if (location.pathname === "/") {
            const el = document.getElementById("settlement");
            if (el) {
                const yOffset = -150;
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo({ top: y, behavior: "smooth" });
            }
            } else {
            navigate("/#settlement");
            }

        }}

    >Settlement</a>
  </li>
  <li className="nav-item">
    <a className="nav-link"
    
        style={{ cursor: "pointer" }}
        onClick={() => {

            if (location.pathname === "/") {
            const el = document.getElementById("newswrap");
            if (el) {
                const yOffset = -150;
                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo({ top: y, behavior: "smooth" });
            }
            } else {
            navigate("/#newswrap");
            }

        }}

    >News</a>
  </li>

  {!IsLogin && (
    <li className="nav-item">
      <a
        className="nav-link"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/loginPage")}
      >
        Login
      </a>
    </li>
  )}

  {IsLogin && (
    <li className="nav-item">
      <div className="dropdown navDrope">
        <button
          className="dropbtn nav-link"
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          👋 {user.name}
        </button>
        <div className={`dropdown-content ${dropdownOpen ? "show" : ""}`}>
          <a href="/dashboard">Dashboard</a>
          <a href="/contact">Contact Us</a>
          <button className="dropdown-item" onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </li>
  )}
</ul>
                            {!IsLogin && (
                                <button 
                                    className="header-btn1" 
                                    type="button" 
                                    onClick={() => navigate("/registerPage")}
                                >
                                    Register
                                </button>
                                )}


                            {modalType && (
                                <Modal modalType={modalType} setModalType={setModalType} onClose={() => setModalType(null)}>
                                    {modalType === "login" ? (
                                        <>
                                            <h2>Login</h2>
                                            <div className="form-field">
                                                <label htmlFor="email">Email address</label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Enter your email"
                                                    className="form-control"
                                                    value={loginData.email}
                                                    onChange={handleLoginChange}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <label htmlFor="password">Password</label>
                                                <input
                                                    type="password"
                                                    name="password"
                                                    placeholder="Enter your password"
                                                    className="form-control"
                                                    value={loginData.password}
                                                    onChange={handleLoginChange}
                                                />
                                            </div>
                                            <div className="form-field extra-class1">
                                                <label htmlFor="checkbox">
                                                    <input type="checkbox" /> Remember me
                                                </label>
                                                <label htmlFor="forgot-pass">
                                                    {/* Updated Forgot Password Link */}
                                                    <a href="#" onClick={() => setModalType("forgot-password")}>Forgot Password?</a>
                                                </label>
                                            </div>
                                            {loginError && <p className="error">{loginError}</p>}
                                            {loginMessage && <p className="success-message">{loginMessage}</p>}
                                            <button className="signin-btn" onClick={handleLoginSubmit}>Sign In</button>
                                        </>
                                    ) : modalType === "register" ? (
                                        <>
                                            <h2>Register</h2>
                                            {registerMessage && <p className="success-message">{registerMessage}</p>}
                                            {Object.keys(registerData).map((field) => (
                                                <div className="form-field" key={field}>
                                                    <label htmlFor={field}>{field.charAt(0).toUpperCase() + field.slice(1)} *</label>

                                                    <input
                                                        type={field === 'dob' ? 'date' : 'text'}
                                                        name={field}
                                                        placeholder={`Enter ${field}`}
                                                        className="form-control"
                                                        value={registerData[field]}
                                                        onChange={handleRegisterChange}
                                                        max={field === 'dob' ? today : undefined} // Disable future dates
                                                    />
                                                    {registerError[field] && <p className="error">{registerError[field]}</p>}
                                                </div>
                                            ))}
                                            <button className="signup-btn" onClick={handleRegisterSubmit}>Sign Up</button>
                                        </>
                                    ) : modalType === "forgot-password" ? (
                                        <>
                                            <h2>Forgot Password</h2>
                                            {forgotPasswordMessage && <p className="success-message">{forgotPasswordMessage}</p>}
                                            {forgotPasswordError && <p className="error">{forgotPasswordError}</p>}
                                            <div className="form-field">
                                                <label htmlFor="email">Email address</label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Enter your email"
                                                    className="form-control"
                                                    value={forgotPasswordEmail}
                                                    onChange={handleForgotPasswordChange}
                                                />
                                            </div>
                                            <button className="submit-btn" onClick={handleForgotPasswordSubmit}>Reset Password</button>
                                        </>
                                    ) : null}
                                </Modal>
                            )}
                            
                        </div>
                    </div>
                </nav>
            </div>
        </section>
    );
}

export default Header;
